import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TlkTextInputComponent } from '@itero/ui-toolkit-angular/text-input';
import { TlkErrorStateMatcher } from '@itero/ui-toolkit-angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DobFormatService } from '../../services/dob-format.service';

@Component({
	selector: 'rx-dob-input',
	standalone: true,
	imports: [CommonModule, FormsModule, TlkTextInputComponent, TranslateModule],
	templateUrl: './dob-input.component.html',
	host: { style: 'display: block' }
})
export class DobInputComponent implements AfterViewInit {
	@Input() label = '';
	@Input() required = false;
	@Input() disabled = false;
	@Input() translationPrefix = 'PatientSection';

	@Input() set value(iso: string) {
		if (iso === this.parsedDateOfBirth) {
			return;
		}

		this.parsedDateOfBirth = iso || '';
		this.displayValue = this.dobFormat.format(iso || '');
		this.dobTouched = !!iso;
	}

	@Output() valueChange = new EventEmitter<string>();

	displayValue = '';
	dobTouched = false;

	dobErrorMatcher: TlkErrorStateMatcher = { isErrorState: () => this.dobTouched && this.isDobInvalid };

	private parsedDateOfBirth = '';

	get isDobInvalid(): boolean {
		return this.dobFormat.isInvalidDob(this.parsedDateOfBirth);
	}

	get placeholder(): string {
		return this.dobFormat.getEffectiveFormat();
	}

	constructor(
		private readonly dobFormat: DobFormatService,
		private readonly cdr: ChangeDetectorRef,
		private readonly elementRef: ElementRef
	) {}

	ngAfterViewInit(): void {
		const input = this.elementRef.nativeElement.querySelector('input');
		if (input) {
			input.setAttribute('inputmode', 'numeric');
		}
	}

	onInput(value: string): void {
		const result = this.dobFormat.applyMask(value);

		if (value !== result) {
			this.displayValue = result + '\0';
			this.cdr.detectChanges();
		}

		this.displayValue = result;
		this.parsedDateOfBirth = this.dobFormat.parse(result);

		if (result.length >= this.dobFormat.getEffectiveFormat().length) {
			this.dobTouched = true;
		}

		this.valueChange.emit(this.parsedDateOfBirth);
	}

	onBlur(): void {
		this.dobTouched = true;
	}
}
